<template>
  <div>
    <b-tabs pills card vertical v-if="futureRisks">
      <b-tab :title="category.title" v-for="(category,index) in futureRisks" :key="index">
        <b-row>
          <!-- google search component  -->
          <b-col
           v-if="category.results && category.results.articles"
            cols="12"
            style="height:calc(100vh - 250px); overflow-y: scroll"
          >
            <h4>Google({{(category.results && category.results.articles.length || 0)}})</h4>

            <SearchResult
              v-for="(item, index) in category.results.articles"
              :key="index"
              :resultData="item"
              :resultIndex="index"
              :keywords="category.searchKeywords"
            ></SearchResult>
            <p
          class="text-center my-5"
          v-if="!category.results.articles.length"
        >No Result Found</p>
          </b-col>
         
          
        </b-row>
        
      </b-tab>
    </b-tabs>
    <p v-else>No Results Found</p>
  </div>
</template>
<script>
import SearchResult from "../../negative-media/search-results.vue";
export default {
  name: "FutureRisksComponent",
  components: {
    SearchResult
  },
  data() {
    return {
      
    };
  },
  mounted() {

    // console.log('this.futureRisks',this.futureRisks);
  },
  computed: {},
  methods: {},
  props: {
    futureRisks: Array
  }
};
</script>